import React, { useEffect, useState } from 'react';
import css from './SectionFlipAndWin.css';
import { useRequest } from '../../../../hooks/useRequest';
import { Alert, IconSpinner } from '../../../../components';
import { Counter } from './Counter';
import { FlipAndWinCards } from './FlipAndWinCards';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCurrentUser, updateUserProfileInfo } from '../../../../ducks/user.duck';
import { evaluateFlipOutcome, getFlipAndWinCards } from '../../../../util/api';
import Partners from './partners';
import { cardAlreadyFlipped } from './helpers';

export default () => {
    const [fetchingCardsError, setFetchingCardsError] = useState(null);

    const dispatch = useDispatch();
    const currentUser = useSelector(state => state.user.currentUser);

    const updateUserProfile = params => dispatch(updateUserProfileInfo(params));
    const fetchCurrentUserData = async () => await dispatch(fetchCurrentUser());

    const { flipAndWinData } = currentUser?.attributes?.profile?.privateData || {
        flipAndWinData: {},
    };
    const { newFlipAllowedAt, cardsFlipped } = flipAndWinData || { cardsFlipped: {} };

    const [cards, setCards] = useState([{}, {}, {}]);

    const { loading: fetchingCardsLoading, request: fetchingCardsRequest } = useRequest();

    const requestCards = async () =>
        await fetchingCardsRequest(
            getFlipAndWinCards,
            data => (Array.isArray(data) ? setCards(data) : null),
            e => {
                const isNotAuthed = e.status === 401;
                if (!isNotAuthed) {
                    setFetchingCardsError(e.message || 'Something went wrong, try later.');
                }
            }
        );

    useEffect(() => {
        requestCards();
    }, []);

    const {
        error: evaluatingCardError,
        loading: evaluatingCardLoading,
        request: evaluatingCardRequest,
    } = useRequest();

    const errors = fetchingCardsError || evaluatingCardError;

    if (fetchingCardsLoading) {
        return <IconSpinner />;
    }

    if (errors) {
        return <Alert showAsPlainText type="failure" description={errors} closeAllowed={false} />;
    }

    const handleCardFlip = cardIndex =>
        evaluatingCardRequest(
            async () =>
                await evaluateFlipOutcome(
                    cards
                        .filter(card => !cardAlreadyFlipped(card, cardsFlipped))
                        .map(({ id }) => id),
                    cardIndex
                ),
            unflippedCard => {
                const otherCards = cards.filter(card => card.id !== unflippedCard.id);

                otherCards.splice(cardIndex, 0, unflippedCard);

                setCards(otherCards);

                fetchCurrentUserData();
            }
        );

    return (
        <section className={css.root}>
            <div className={css.content}>
                <div>
                    <Counter
                        newFlipAllowedAt={newFlipAllowedAt}
                        updateUserProfile={updateUserProfile}
                        flipAndWinData={flipAndWinData}
                        requestCards={requestCards}
                    />
                    <FlipAndWinCards
                        loading={evaluatingCardLoading}
                        cards={cards}
                        handleCardFlip={handleCardFlip}
                    />
                </div>
            </div>
            <div className={css.partners}>
                <Partners />
                <Partners />
            </div>
        </section>
    );
};
